import styled from 'styles/styled';
import imgCount from '../../../assets/countBG.svg';
import photoDesktop from '../../../assets/fullbodyJoin.png';

export const Wrapper = styled.div`
`;

export const Count = styled.h4`
  font-size: 55px;
  font-weight: 700;
  line-height: 120px;
  text-align: center;
  color: #000;
  max-width: 390px;
  width: 100%;
  background-image: url(${imgCount});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  height: 120px;
  min-width: 390px;
  margin-top: -30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Row = styled.div`
  margin-bottom: 28px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const SubTitle = styled.h4`
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  margin-bottom: 24px;
  color: #EFEFEF;
  @media (max-width: 720px) {
    font-size: 16px;
  }
`;

export const SubTitleLarge = styled.h3`
  font-size: 22px;
  font-weight: 500;
  line-height: 28px;
  color: #EFEFEF;
  text-align: center;
  margin: 0 0 25px 0;
  span {
    color: #52D381;
  }
`;

export const ErrorInfo = styled.h4`
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  text-align: center;
  margin: 0 0 25px 0;
  color: #FF4B4A;
`;

export const LoadAnime = styled.div`
  display: block;
  width: 52px;
  height: 52px;
  animation: rotation 800ms infinite linear;
  border-radius: 100%;
  margin-bottom: 10px;
  box-shadow: 1px 1px 0 1px #52d382;
  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;

// --- Tournament Join Preview ---

export const JoinPreviewWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
  padding: 0 16px;
`;

export const JoinTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: #EFEFEF;
  text-align: center;
  margin-bottom: 4px;

  @media (max-width: 720px) {
    font-size: 20px;
  }
`;

export const JoinStatus = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #EFEFEF;
  text-align: center;
  opacity: 0.8;
  margin-bottom: 24px;

  @media (max-width: 720px) {
    font-size: 14px;
  }
`;

export const CountdownLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #EFEFEF;
  opacity: 0.7;
  margin-bottom: 6px;
`;

export const CountdownValue = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: #EFEFEF;
  background: rgba(239, 239, 239, 0.12);
  border-radius: 999px;
  padding: 10px 32px;
  margin-bottom: 28px;

  @media (max-width: 720px) {
    font-size: 18px;
    padding: 8px 24px;
  }
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 3px;
`;

export const DetailLabel = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #EFEFEF;
  width: 50%;
  text-align: right;
  margin: 0 5px;

  @media (max-width: 720px) {
    font-size: 12px;
  }
`;

export const DetailValue = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #52D381;
  width: 50%;
  text-align: left;
  margin: 0 5px;

  @media (max-width: 720px) {
    font-size: 12px;
  }
`;

export const UsdHint = styled.span`
  font-weight: 400;
  color: #999;
  margin-left: 4px;
`;

export const JoinButtonWrap = styled.div`
  margin-top: 32px;
  width: 100%;
  max-width: 320px;

  button {
    width: 100%;
    min-height: 48px;
    font-size: 16px;
    font-weight: 700;
  }
`;

// --- Join page card layout (matching TournamentLobby/share style) ---

export const JoinCard = styled.section`
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 32px 24px;
  background: linear-gradient(180deg, #15191e 0%, #000000 15%, #000000 33%, #15191e 100%);
  border-radius: 24px;
  text-align: center;
  color: #efefef;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 720px) {
    padding: 24px 16px;
    border-radius: 0 16px 16px 16px;
  }
`;

export const JoinLogo = styled.div`
  width: 100%;
  max-width: 480px;
  height: 200px;
  background-image: url(${photoDesktop});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin: 0 auto 20px auto;
  flex-shrink: 0;

  @media (max-width: 720px) {
    max-width: 320px;
    height: 140px;
  }
`;
